import React from "react";
// Import Section Heading
import SectionHeading from "../../Common/SectionHeading";
import { ReviewData } from "../../Common/CustomerReview/ReviewData";
import ReviewCard from "../../Common/CustomerReview/ReviewCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomerReview = () => {
  const settings = {
    dots: true, // Enable pagination dots
    infinite: true, // Allow infinite scrolling
    speed: 500, // Transition speed
    slidesToShow: 3, // Show 3 reviews at a time
    slidesToScroll: 1, // Slide one review at a time
    autoplay: true, // Enables automatic sliding
    autoplaySpeed: 3000, // Slides every 3 seconds
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: "#ccc",
          margin: "0 5px",
          cursor: "pointer",
        }}
      />
    ),
    appendDots: (dots) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        {dots.slice(0, 5)} {/* Only display the first 5 dots */}
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2, // Show 2 reviews on tablet screens
          slidesToScroll: 1, // Slide one review at a time
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // Show 1 review on mobile screens
          slidesToScroll: 1, // Slide one review at a time
        },
      },
    ],
  };
  

  return (
    <section id="customer_reviews" className="section_padding_bottom">
      <div className="container">
        <SectionHeading heading="Customer Review" />
        <Slider {...settings}>
          {ReviewData.map((data, index) => (
            <ReviewCard
              img={data.img}
              para={data.review}
              date={data.date}
              name={data.name}
              des={data.des}
              status={data.status}
              key={index}
            />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default CustomerReview;
